import { Font } from "@react-pdf/renderer";
import OpenSansRegular from "./fonts/OpenSans/OpenSans-Regular.ttf";
import OpenSansBold from "./fonts/OpenSans/OpenSans-Bold.ttf";
import FontAwesome from "./fonts/FontAwesome/fa-regular-400.ttf";
import FontAwesomeSolid from "./fonts/FontAwesome/fa-solid-900.ttf";
import FontAwesomeBrands from "./fonts/FontAwesome/fa-brands-400.ttf";
import MontserratRegular from "./fonts/Montserrat/Montserrat-Regular.ttf";
import MontserratBold from "./fonts/Montserrat/Montserrat-Bold.ttf";
import RobotoRegular from "./fonts/Roboto/Roboto-Regular.ttf";
import RobotoBold from "./fonts/Roboto/Roboto-Bold.ttf";

Font.register({
  family: "Roboto",
  fonts: [
    {
      src: RobotoRegular
    },
    {
      src: RobotoBold,
      fontWeight: 700
    }
  ]
});

Font.register({
  family: "Montserrat",
  fonts: [
    {
      src: MontserratRegular
    },
    {
      src: MontserratBold,
      fontWeight: 700
    }
  ]
});

Font.register({
  family: "OpenSans",
  fonts: [
    {
      src: OpenSansRegular
    },
    {
      src: OpenSansBold,
      fontWeight: 700
    }
  ]
});

Font.register({
  family: "FontAwesome",
  fonts: [
    {
      src: FontAwesome
    },
    {
      src: FontAwesomeSolid,
      fontWeight: 900
    }
  ]
});

Font.register({
  family: "FontAwesomeBrands",
  fonts: [
    {
      src: FontAwesomeBrands
    },
    {
      src: FontAwesomeBrands,
      fontWeight: 900
    }
  ]
});
